import React from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import { ButtonDelete } from '../Buttons/Buttons';
import ButtonAutorizar from '../Buttons/ButtonAutorizar';
import ButtonDesconocido from '../Buttons/ButtonDesconocido';
import './ModalDispositivosUsuario.css';

const ModalDispositivosUsuario = ({ isOpen, onClose, usuario, dispositivos, onEliminar, onToggle, formatFecha, estadosDispositivo }) => {
    if (!isOpen || !usuario) return null;

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>DISPOSITIVOS DE {usuario.nombre_completo}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <div className="info-usuario">
                        <p><strong>Código:</strong> {usuario.codigo_usuario}</p>
                        <p><strong>Total dispositivos:</strong> {dispositivos.length}</p>
                    </div>
                    <Table className="tabla-dispositivos-modal">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Dispositivo</th>
                                <th>IP</th>
                                <th>Estado</th>
                                <th>Primer acceso</th>
                                <th>Último acceso</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dispositivos.map((d, idx) => (
                                <tr key={d.dispositivo_id}>
                                    <td>{idx + 1}</td>
                                    <td>{d.nombre_dispositivo}</td>
                                    <td>{d.ip_address || '—'}</td>
                                    <td>
                                        {(() => {
                                            const tipoId = Number(d.activo);
                                            const est = estadosDispositivo.find(e => Number(e.tipo_id) === tipoId);
                                            const cls = [4, 5, 6].includes(tipoId) ? `estado-dispositivo estado-${tipoId}` : 'estado-dispositivo estado-default';
                                            return <span className={cls}>{est ? est.descripcion : tipoId}</span>;
                                        })()}
                                    </td>
                                    <td>{formatFecha(d.fecha_registro)}</td>
                                    <td>{formatFecha(d.ultimo_acceso)}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                            {Number(d.activo) === 5 ? (
                                                <ButtonAutorizar onClick={() => onToggle(d.dispositivo_id)} disabled={false} />
                                            ) : (
                                                <ButtonDesconocido onClick={() => onToggle(d.dispositivo_id)} disabled={Number(d.activo) === 4} />
                                            )}
                                            <ButtonDelete onClick={() => onEliminar(d)} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalDispositivosUsuario;
